import type { AccessLevel } from '@/domain/apiUsers';

import type { ClientCage, ClientLocation } from '../ClientContainer';

interface ListItem {
    selected: boolean;
}
export interface CageListItem extends ClientCage, ListItem {}

export interface LocationListItem extends ListItem {
    id: number;
    name: string;
    cages: CageListItem[];
}

// Reducer types
export type LocationAction =
    | { type: 'TOGGLE_LOCATION'; locationId: number }
    | { type: 'TOGGLE_CAGE'; locationId: number; cageId: number }
    | { type: 'RESET'; clientLocations: ClientLocation[] };

interface LocationState {
    locationsList: LocationListItem[];
}

export function makeInitialLocationsList(clientLocations: ClientLocation[]): LocationListItem[] {
    return clientLocations.map((location) => ({
        id: location.id,
        name: location.name,
        cages: location.cages.map((cage) => ({ ...cage, selected: false })),
        selected: false,
    }));
}

export const ACCESS_LEVEL_DESCRIPTION_KEYS: Record<AccessLevel, string> = {
    client: 'internal.createApiUser.descriptions.client',
    location: 'internal.createApiUser.descriptions.location',
    cage: 'internal.createApiUser.descriptions.cage',
};

export function parseAccessLevelToId(accessLevel: AccessLevel): number {
    switch (accessLevel) {
        case 'client':
            return 1;
        case 'location':
            return 2;
        case 'cage':
            return 3;
    }
}

export function locationReducer(state: LocationState, action: LocationAction): LocationState {
    switch (action.type) {
        case 'TOGGLE_LOCATION':
            return {
                locationsList: state.locationsList.map((location) => {
                    if (location.id === action.locationId) {
                        return { ...location, selected: !location.selected };
                    }
                    return location;
                }),
            };

        case 'TOGGLE_CAGE':
            return {
                locationsList: state.locationsList.map((location) => {
                    if (location.id === action.locationId) {
                        return {
                            ...location,
                            cages: location.cages.map((cage) => {
                                if (cage.id === action.cageId) {
                                    return { ...cage, selected: !cage.selected };
                                }
                                return cage;
                            }),
                        };
                    }
                    return location;
                }),
            };

        case 'RESET':
            return {
                locationsList: makeInitialLocationsList(action.clientLocations),
            };

        default:
            return state;
    }
}
